import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css"
import InputNumber from 'rc-input-number';

const Numberinput = ({ id, label, placeholder, value, example, disabled, mandatory, md }) => {
    const { handleChange } = useContext(FormContext)
    return (
        <Col md={md} className="pad-trl-10">
        <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
            {/* <InputNumber defaultValue={10} 
            // className="form-control move-left custom-input" 
            // onChange={event => handleChange(id, event)}
             /> */}
            <input type="number" className="form-control move-left custom-input" id="exampleInputEmail1" aria-describedby="emailHelp"
                placeholder={placeholder ? placeholder : 'Enter a number'}
                value={value}
                onChange={event => handleChange(id, event)}
                disabled={disabled}
                required={mandatory}
                autoComplete="new-password"
            />
        </div>
        </Col>
    )
}

export default Numberinput